﻿<script lang="ts">
    import { List, ListGroup, ListItem } from 'framework7-svelte';
    import { _ } from 'svelte-i18n';
    
    import FloatingButton from '../FloatingButton.svelte';

    const MAPBOX_CONGESTION_OPTIONS: { label: string; value: string }[] = [
        { label: $_('pages.project.MAPBOX_CONGESTION_SEVERE'), value: 'Severe' },
        { label: $_('pages.project.MAPBOX_CONGESTION_HEAVY'), value: 'Heavy' },
        { label: $_('pages.project.MAPBOX_CONGESTION_MODERATE'), value: 'Moderate' }
    ];

    export let congestionProfile: string[] = [];

    function onToggleCongestionMode(event) {
        const congestionMode: string = event.target.value;
        if (congestionProfile.includes(congestionMode)) {
            congestionProfile = congestionProfile.filter((x) => x !== congestionMode);
        } else {
            congestionProfile = [...congestionProfile, congestionMode];
        }
    }
</script>

<FloatingButton label="Mapbox traffic" active={(congestionProfile ?? []).length > 0} activeIcon="check" inactiveIcon="" popoverWidth="346px">
    <List ul={false}>
        <ListGroup>
            <ListItem title="{$_('pages.project.MAPBOX_TRAFFIC_DROPDOWN_LABEL')}" groupTitle />
            {#each MAPBOX_CONGESTION_OPTIONS as option}
                <ListItem
                    checkbox
                    checkboxIcon="end"
                    value={option.value}
                    title={option.label}
                    checked={congestionProfile.includes(option.value)}
                    onChange={onToggleCongestionMode}
                />
            {/each}
        </ListGroup>
    </List>
</FloatingButton>
